import React from 'react';

import {
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type Props = {
  rows: any[];
  loading?: boolean;
  onDeclareReady?: (row: any) => void;
};

const text = (...values: any[]) => {
  const value = values.find(
    x =>
      x !== null &&
      x !== undefined &&
      String(x).trim() !== ''
  );

  return value == null ? '' : String(value);
};

export default class ActivityPlanningRegisterPanel
  extends React.PureComponent<Props> {

  render() {
    const {
      rows = [],
      loading = false,
      onDeclareReady,
    } = this.props;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1.5 }}
        >
          <Box>
            <Typography variant="h6">
              Cost Centre Planning Register
            </Typography>

            <Typography
              variant="caption"
              color="text.secondary"
            >
              All active Activity Plans for the governed Cost
              Centre and Planning Cycle. Strategic filters below
              do not change this register.
            </Typography>
          </Box>

          <Chip
            size="small"
            label={`${rows.length} Activity Plan${rows.length === 1 ? '' : 's'
              }`}
          />
        </Stack>

        <TableContainer sx={{ maxHeight: 360 }}>
          <Table size="small" stickyHeader>

            <TableHead>
              <TableRow>
                <TableCell>Activity</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>State</TableCell>
                <TableCell>Validation</TableCell>
                <TableCell align="right">Tasks</TableCell>
                <TableCell align="right">Budget Lines</TableCell>
                <TableCell align="right">Planned Amount</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>

              {rows.map((r: any, i: number) => {

                const statecode =
                  text(r.statecode).toUpperCase();

                const isReady = Boolean(r.isready);
                const isValid = Boolean(r.isvalid);
                const canReady = Boolean(r.canready);

                return (
                  <TableRow
                    key={text(
                      r.activityplanid,
                      r.rid,
                      r.recix,
                      i
                    )}
                    hover
                  >
                    <TableCell>
                      {text(
                        r.activitycode,
                        r.shc,
                        r.code
                      )}
                    </TableCell>

                    <TableCell>
                      {text(
                        r.activityname,
                        r.nam,
                        r.name
                      )}
                    </TableCell>

                    <TableCell>
                      <Chip
                        size="small"
                        variant={
                          isReady
                            ? 'filled'
                            : 'outlined'
                        }
                        label={
                          statecode ||
                          text(r.statename, 'PLANNED')
                        }
                      />
                    </TableCell>

                    <TableCell>
                      <Chip
                        size="small"
                        variant="outlined"
                        label={
                          isValid
                            ? 'Valid'
                            : `${Number(
                              r.blockingcount ?? 0
                            )} Blocking`
                        }
                      />
                    </TableCell>

                    <TableCell align="right">
                      {Number(r.taskcount ?? 0)}
                    </TableCell>

                    <TableCell align="right">
                      {Number(r.budgetlinecount ?? 0)}
                    </TableCell>

                    <TableCell align="right">
                      {Number(
                        r.plannedamount ??
                        r.totalamount ??
                        0
                      ).toLocaleString()}
                    </TableCell>

                    <TableCell align="right">
                      {canReady ? (
                        <Button
                          size="small"
                          variant="outlined"
                          disabled={loading}
                          onClick={() =>
                            onDeclareReady?.(r)
                          }
                        >
                          Declare Ready
                        </Button>
                      ) : isReady ? (
                        <Chip
                          size="small"
                          label="Ready"
                        />
                      ) : !isValid ? (
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          Resolve issues
                        </Typography>
                      ) : (
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          —
                        </Typography>
                      )}
                    </TableCell>

                  </TableRow>
                );
              })}

              {!rows.length && (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                      No Activity Plans are registered for this
                      Cost Centre.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

            </TableBody>
          </Table>
        </TableContainer>

      </Paper>
    );
  }
}